module.exports = __webpack_public_path__ + "static/media/waze.3ebd4afb.svg";